import React, { useEffect, useState } from "react";
import { api, CATEGORY_STYLE } from "../lib/api";
import AdminHeader from "../components/AdminHeader";
import { CheckCircle2, XCircle, Music, VolumeX } from "lucide-react";

export default function AuditLog() {
  const [logs, setLogs] = useState([]);

  useEffect(() => { api.get("/audit").then((r) => setLogs(r.data)); }, []);

  const fmt = (iso) => {
    if (!iso) return "—";
    const d = new Date(iso);
    return d.toLocaleDateString() + " " + d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", second: "2-digit" });
  };

  return (
    <div className="min-h-screen bg-[#09090B] p-4 md:p-6">
      <AdminHeader title="AUDIT LOG" accent="#FF3B30" />
      <p className="text-[#71717A] mb-5">Safeguarding record of every priority / emergency recording triggered.</p>
      <div className="bg-[#18181B] border border-white/10 rounded-2xl overflow-hidden">
        <div className="grid grid-cols-[1.5fr_1fr_1fr_0.8fr_0.8fr] gap-2 px-4 py-3 border-b border-white/10 text-[#71717A] font-bold text-xs tracking-widest uppercase">
          <div>Recording</div><div>Triggered By</div><div>Date / Time</div><div>Music</div><div>Completed</div>
        </div>
        {logs.map((l) => {
          const s = CATEGORY_STYLE[l.category] || CATEGORY_STYLE.General;
          return (
            <div key={l.id} data-testid={`audit-row-${l.id}`} className="grid grid-cols-[1.5fr_1fr_1fr_0.8fr_0.8fr] gap-2 px-4 py-3 border-b border-white/5 items-center">
              <div className="flex items-center gap-2">
                <span className="w-2 h-8 rounded-full" style={{ background: s.bg }} />
                <span className="font-bold text-white">{l.audio_name}</span>
              </div>
              <div className="text-[#A1A1AA]">{l.triggered_by}</div>
              <div className="text-[#A1A1AA] text-sm">{fmt(l.triggered_at)}</div>
              <div>{l.music_was_playing ? <Music className="w-5 h-5 text-[#FF007F]" /> : <VolumeX className="w-5 h-5 text-[#52525B]" />}</div>
              <div>{l.completed ? <CheckCircle2 className="w-5 h-5 text-[#00FA9A]" /> : <XCircle className="w-5 h-5 text-[#FFCC00]" />}</div>
            </div>
          );
        })}
        {logs.length === 0 && <div className="px-4 py-8 text-center text-[#71717A]">No recordings triggered yet.</div>}
      </div>
    </div>
  );
}
